import { Link } from 'react-router-dom';

const section = (title, children) => (
    <div style={{ marginBottom: '32px' }}>
        <h2 style={{ color: '#ffc107', fontSize: '1.1rem', fontWeight: 700, marginBottom: '10px', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '8px' }}>
            {title}
        </h2>
        {children}
    </div>
);

const p = (text) => (
    <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, margin: '0 0 12px' }}>{text}</p>
);

function TermsOfService() {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff',
        }}>
            <div style={{ maxWidth: '760px', margin: '0 auto', padding: '48px 24px 64px' }}>
                <Link to="/dashboard" style={{ color: 'rgba(255,193,7,0.7)', fontSize: '0.85rem', textDecoration: 'none' }}>
                    ← Back to Dashboard
                </Link>

                <h1 style={{ marginTop: '24px', marginBottom: '8px', fontSize: '2rem', fontWeight: 700 }}>
                    Terms of Service
                </h1>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginBottom: '40px' }}>
                    Effective Date: April 25, 2026
                </p>

                {section('1. Acceptance of Terms',
                    p('By creating an account or using the You-Bee platform ("Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.')
                )}

                {section('2. Description of Service',
                    <>
                        {p('You-Bee is a Universal Basic Income (UBI) platform that facilitates voluntary contributions to community pools and distributes accumulated funds to eligible recipients via the Solana blockchain.')}
                        {p('You-Bee acts as a platform intermediary. We do not guarantee any specific amount or frequency of distributions. Pool balances and distribution amounts depend entirely on voluntary contributions from other users.')}
                        {p('You-Bee is a for-profit platform. Contributions are not tax-deductible. You-Bee is not an investment platform, exchange, or financial product. Contributions made to pools are voluntary and non-refundable. Contributors receive no equity, interest, yield, profit share, token, or any other financial return in exchange for their contribution. Recipients of distributions have no entitlement to any specific amount, schedule, or continuity of distributions.')}
                    </>
                )}

                {section('3. Eligibility',
                    <>
                        {p('You must be at least 18 years of age to use You-Bee. By registering, you represent that you meet this requirement.')}
                        {p('You-Bee is available exclusively to residents of the United States. By registering, you represent and warrant that you are a current resident of the United States. Use of this platform from outside the United States is strictly prohibited.')}
                        {p('Participation in distributions requires successful completion of Know Your Customer (KYC) identity verification. You-Bee reserves the right to withhold distributions and restrict account features until KYC approval is confirmed. Submitting false or fraudulent identity documents will result in permanent account termination.')}
                        {p('Distribution eligibility is determined by the profile information you provide, including your profession, city, and state. It is your responsibility to ensure this information is accurate. Providing false information may result in account termination.')}
                    </>
                )}

                {section('4. Custodial Wallets',
                    <>
                        {p('Upon registration, You-Bee creates a custodial Solana wallet on your behalf. You-Bee holds the private key for this wallet. You acknowledge that:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li>You do not directly control the private key to your custodial wallet</li>
                            <li>Distributions are sent to your custodial wallet as USDC, a US dollar-pegged stablecoin on the Solana blockchain</li>
                            <li>You may withdraw your balance by transferring USDC directly to an external Solana wallet address, or spend it using a Rain Visa Card. A 5% platform fee applies to all withdrawals. Withdrawals are subject to identity verification requirements.</li>
                            <li>A 5% platform administration fee is applied to all give-back transactions processed through your custodial wallet</li>
                            <li>You may opt in to an automatic daily give-back feature, which returns your earnings from that day to the You Bee General Hive each night. A 5% platform fee applies to each automatic give-back transaction. You may disable this feature at any time from your profile settings.</li>
                        </ul>
                    </>
                )}

                {section('5. Contributions & Platform Fee',
                    <>
                        {p('Contributions to pools are voluntary and made in USDC, a US dollar-pegged stablecoin on the Solana blockchain. Once a contribution is submitted to the blockchain, it cannot be reversed or refunded.')}
                        {p('Platform administration fees are applied as follows: (a) a 5% fee is deducted from contributions sent from your You-Bee wallet to a pool, withdrawals to external wallets, and automatic or manual give-back transactions; (b) a 3% fee is applied to direct external deposits made to pool wallets from outside the platform. Fees are deducted at the time of the on-chain transaction and transferred directly to the You-Bee platform wallet.')}
                        {p('By making a contribution, you acknowledge and agree that: (a) your contribution is voluntary with no expectation of financial return, profit, yield, or repayment; (b) you are not purchasing a security, investment product, or financial instrument; (c) you have no claim to pool funds after contribution; and (d) You-Bee makes no representation that pool funds will grow or that distributions will occur at any particular time or amount.')}
                    </>
                )}

                {section('6. No Investment; No Financial Advice',
                    <>
                        {p('You-Bee is not an investment platform. Participating in You-Bee — whether as a contributor or a distribution recipient — does not constitute an investment, and no profit, return, or financial gain is promised or implied.')}
                        {p('Nothing on the You-Bee platform constitutes financial, investment, tax, or legal advice.')}
                        {p('Payments received through You-Bee may be considered taxable income. Consult a tax advisor or report as "Other Income" on your federal return.')}
                    </>
                )}

                {section('7. Custodial Wallet Deposits',
                    <>
                        {p('You-Bee generates and manages a Solana custodial wallet on your behalf. Due to the permissionless nature of the Solana blockchain, You-Bee cannot restrict or prevent third parties from sending cryptocurrency to your custodial wallet address. Any funds received from external sources are not platform-managed distributions and are solely your responsibility.')}
                        {p('You-Bee is not liable for any funds received from unknown or unauthorized external sources. External deposits do not affect your eligibility for platform distributions and are not subject to the platform\'s give-back or reclamation policies unless your account becomes inactive.')}
                    </>
                )}

                {section('8. Blockchain Risks',
                    <>
                        {p('Use of You-Bee involves inherent risks associated with blockchain technology, including but not limited to:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li>Network congestion or outages on the Solana blockchain</li>
                            <li>Smart contract bugs or exploits</li>
                            <li>Regulatory changes affecting cryptocurrency</li>
                        </ul>
                        {p('You-Bee is not liable for losses arising from these risks.')}
                    </>
                )}

                {section('9. Acceptable Use',
                    <>
                        {p('You agree not to:')}
                        <ul style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, paddingLeft: '20px', margin: '0 0 12px' }}>
                            <li>Create multiple accounts to gain unfair distribution advantages</li>
                            <li>Provide false or misleading profile information</li>
                            <li>Attempt to exploit, reverse-engineer, or disrupt the platform or smart contracts</li>
                            <li>Use the platform for money laundering or other illegal purposes</li>
                        </ul>
                    </>
                )}

                {section('10. Account Termination',
                    p('We reserve the right to suspend or terminate accounts that violate these Terms, provide false information, or engage in fraudulent activity. In the event of termination, any custodial wallet balance will be handled in accordance with our operational policies at the time.')
                )}

                {section('11. Limitation of Liability',
                    p('To the maximum extent permitted by law, You-Bee and its operators shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including loss of funds, loss of data, or service interruptions.')
                )}

                {section('12. Changes to Terms',
                    p('We may update these Terms from time to time. Continued use of the Service after changes are posted constitutes acceptance of the revised Terms. Material changes will be communicated via the platform.')
                )}

                {section('13. Governing Law',
                    p('These Terms are governed by the laws of the State of Delaware, United States, without regard to conflict of law principles.')
                )}

                {section('14. Regulatory Compliance',
                    <>
                        {p('You-Bee complies with applicable US federal and state regulations, including anti-money laundering (AML) and Know Your Customer (KYC) requirements. You-Bee may use third-party identity verification services to fulfill these obligations, and KYC data is handled in accordance with our Privacy Policy.')}
                        {p('It is your sole responsibility to ensure that your use of this platform complies with all laws applicable in your jurisdiction. You-Bee is not responsible for any tax obligations arising from distributions or give-back transactions.')}
                    </>
                )}

                {section('15. Contact',
                    p('For questions about these Terms, contact us at: legal@you-bee.com')
                )}

                <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: '24px' }}>
                    <Link to="/privacy" style={{ color: 'rgba(255,193,7,0.7)', fontSize: '0.85rem', textDecoration: 'none' }}>Privacy Policy</Link>
                    <Link to="/dashboard" style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', textDecoration: 'none' }}>Back to Dashboard</Link>
                </div>
            </div>
        </div>
    );
}

export default TermsOfService;
